import { render, staticRenderFns } from "./userData.vue?vue&type=template&id=0b43448e"
import script from "./userData.vue?vue&type=script&lang=js"
export * from "./userData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports